// extracted by mini-css-extract-plugin
export default {"main":"IdvBlogSec_main__dasts","footer":"IdvBlogSec_footer__8XLfJ","socials":"IdvBlogSec_socials__gNC88","para_main":"IdvBlogSec_para_main__9SQP9"};